export default __webpack_public_path__ + "static/media/emptyField.a4e8f3a0.svg";